import { z } from 'zod';
import { isWholeQuantity } from '../utils/is-whole-quantity.js';
import { WHOLE_QUANTITY_MESSAGE } from '../validation/quantity/whole-quantity-message.js';
import { shipLineCaptureInputSchema } from '../validation/sales-order/ship-line-capture-input.js';
import { requiredUuidString } from '../validation/zod-helpers/index.js';
const captureRowSchema = z
    .object({
    salesOrderItemId: requiredUuidString('Line is required.', 'Invalid line selection.'),
    shippedQty: z.number(),
    /** The line's or its part's unit is counted in whole pieces. */
    qtyIsIntegral: z.boolean(),
    qtyRejected: z
        .number({ error: 'Enter a rejected quantity of 0 or more.' })
        .min(0, 'Enter a rejected quantity of 0 or more.'),
    rejectionReason: z.string(),
})
    .superRefine((row, context) => {
    // The API refuses these without a field path, so the dialog must catch them first.
    if (row.qtyRejected > row.shippedQty) {
        context.addIssue({
            code: 'custom',
            path: ['qtyRejected'],
            message: `Rejected can't be more than the ${row.shippedQty} shipped.`,
        });
    }
    if (row.qtyIsIntegral && !isWholeQuantity(row.qtyRejected)) {
        context.addIssue({ code: 'custom', path: ['qtyRejected'], message: WHOLE_QUANTITY_MESSAGE });
    }
    if (!(row.qtyRejected > 0))
        return;
    // The API's own quantity and reason rules, so the dialog refuses exactly what Mark Delivered would.
    const quantity = shipLineCaptureInputSchema.shape.qtyRejected.safeParse(row.qtyRejected);
    const quantityMessage = quantity.error?.issues[0]?.message;
    if (quantityMessage) {
        context.addIssue({ code: 'custom', path: ['qtyRejected'], message: quantityMessage });
    }
    const reason = shipLineCaptureInputSchema.shape.rejectionReason.safeParse(row.rejectionReason);
    const message = reason.error?.issues[0]?.message;
    if (message)
        context.addIssue({ code: 'custom', path: ['rejectionReason'], message });
});
/** Mark Delivered's rows: one per shipped line; delivered is shipped minus rejected (DLV spec §5.3). */
export const markDeliveredCaptureSchema = z.array(captureRowSchema);
export const markDeliveredFormSchema = z.object({ capture: markDeliveredCaptureSchema });
//# sourceMappingURL=mark-delivered-form.js.map